import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EnvironmentService} from '@core/environment/environment.service';
import {ConsentChapterBasicModel} from './response/consent-chapter-basic.model';
import {ConsentChapterModel} from './response/consent-chapter.module';

@Injectable()
export class ConsentChapterRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/chapter';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getConsentChapters(): Observable<ConsentChapterBasicModel[]> {
        return this.httpClient.get<ConsentChapterBasicModel[]>(this.controllerUrl);
    }

    getConsentChapter(consentChapterId: string): Observable<ConsentChapterModel> {
        return this.httpClient.get<ConsentChapterModel>(this.controllerUrl + `/${consentChapterId}`);
    }
}
